import { cn } from '@sr/ui-library';

/**
 * Page heading shared by every MSR3 onboarding step.
 *
 * Onboarding headings take the brand red — the flow's own convention, applied
 * to every step from "Create Your Profile" through "Review Your Clients" so no
 * step reads as a different kind of page. Elsewhere in the app headings stay in
 * the dark foreground colour.
 *
 * The `!` is load-bearing: index.css colours every heading inside
 * `.single-customer-app` with --ui-foreground at a higher specificity than a
 * utility class, so the colour only lands as `!text-primary`. Drop the `!` when
 * that block goes post-launch.
 *
 * Kept in one place so weight and colour stay in step across the flow rather
 * than being repeated (and drifting) on each step page.
 */
export const OnboardingHeading = ({
  className,
  ...props
}: React.ComponentProps<'h1'>) => (
  <h1
    className={cn('text-lg font-semibold !text-primary md:text-xl', className)}
    {...props}
  />
);
